import { render, staticRenderFns } from "./RequestAuctionGrantApprovalAction.vue?vue&type=template&id=1719cc15&scoped=true&"
import script from "./RequestAuctionGrantApprovalAction.vue?vue&type=script&lang=ts&"
export * from "./RequestAuctionGrantApprovalAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1719cc15",
  null
  
)

export default component.exports